import consumer from "channels/consumer"
import htmx from "htmx.org"
export default class {
  constructor(userWritingId, feedbackEl, votingEl) {
    this.userWritingId = userWritingId
    this.feedbackEl = feedbackEl
    this.votingEl = votingEl
  }

  start() {
    this.subscription = consumer.subscriptions.create({ "channel": "BarReview::EssayFeedbackChannel", "user_writing_id": this.userWritingId }, {
      received: (data) => {
        if (data.action === "update") {
          this.feedbackEl.outerHTML = data.feedback
          this.votingEl.outerHTML = data.voting
          // Process HTMX on the rendered voting component
          htmx.process(document.getElementById(data.votingElementId))
          consumer.subscriptions.remove(this.subscription) // the page no longer needs to subscribe for changes.
        }
      }
    })
  }
}
